import React, { useEffect, useState } from "react";
import {
  GoogleMap,
  Polyline,
  LoadScript,
  Marker,
} from "@react-google-maps/api";
import LinearProgress from "@mui/material/LinearProgress";
import { useNavigate } from "react-router-dom";

const containerStyle = {
  width: "100%",
  height: "100%",
};

interface TrackingData {
  qrCode: string;
  latitude: number;
  longitude: number;
  lockStatus: number;
  speed: number;
  Distance: number;
  Increamental_Distance: number;
  createdTime: string;
}

interface MapLiveProps {
  trackingData: TrackingData[];
}

function MapLive({ trackingData = [] }: MapLiveProps) {
  const [mapPath, setMapPath] = useState<google.maps.LatLngLiteral[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (trackingData.length > 0) {
      const path = trackingData.map((point) => ({
        lat: point.latitude,
        lng: point.longitude,
      }));
      setMapPath(path);
    }
  }, [trackingData]);

  const calculateCenter = () => {
    if (trackingData.length === 0) {
      return { lat: 0, lng: 0 };
    }
    const mid = Math.floor(trackingData.length / 2);
    return {
      lat: trackingData[mid].latitude,
      lng: trackingData[mid].longitude,
    };
  };

  const center = calculateCenter();

  return (
    <>
      {trackingData.length > 0 ? (
        <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={12}>
          <Polyline
            path={mapPath}
            options={{
              strokeColor: "#FF0000",
              strokeOpacity: 1.0,
              strokeWeight: 3,
            }}
          />
          {/* Start Marker */}
          <Marker
           position={mapPath[mapPath.length - 1]}
            label={{ text: "Start", color: "white" }}
            icon={{
              url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png",
            }}
          />
          {/* End Marker */}
          <Marker
           position={mapPath[0]}
            
            label={{ text: "End", color: "white" }}
            icon={{
              url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
            }}
          />
        </GoogleMap>
      ) : (
        <div className="w-full">
          <LinearProgress
            sx={{
              backgroundColor: "white",
              "& .MuiLinearProgress-bar": { backgroundColor: "#00CD5B" },
            }}
          />
        </div>
      )}
    </>
  );
}

export default MapLive;
